// import React, { useEffect, useState } from "react";
// import { collection, getDocs, orderBy, query, limit } from "firebase/firestore";
// import { db } from "../firebase";
// import "../css/dashboard.css";

// const STAT_CARDS = [
//   {
//     key:   "helpRequests",
//     label: "Help Requests",
//     icon:  "📋",
//     col:   "HelpRequests",
//     color: "#162f06",
//     bg:    "#eef4eb",
//   },
//   {
//     key:   "sadqaBox",
//     label: "Sadqa Box",
//     icon:  "📦",
//     col:   "SadqaBoxRequests",
//     color: "#c49827",
//     bg:    "#fdf8e1",
//   },
//   {
//     key:   "members",
//     label: "Member Applications",
//     icon:  "🤝",
//     col:   "MemberAgreements",
//     color: "#2980b9",
//     bg:    "#eaf4fb",
//   },
//   {
//     key:   "volunteers",
//     label: "Volunteer Applications",
//     icon:  "🙋",
//     col:   "VolunteerAgreements",
//     color: "#27ae60",
//     bg:    "#e8f8ee",
//   },
//   {
//     key:   "mails",
//     label: "Contact Mails",
//     icon:  "📧",
//     col:   "Mails",
//     color: "#8e44ad",
//     bg:    "#f5edfb",
//   },
//   {
//     key:   "collection",
//     label: "Collections",
//     icon:  "💰",
//     col:   "Collection",
//     color: "#e67e22",
//     bg:    "#fef3e6",
//   },
// ];

// const QUICK_LINKS = [
//   { label: "View Help Requests",  icon: "📋", menu: "Report" },
//   { label: "Sadqa Box Requests",  icon: "📦", menu: "SadqaBoxAdmin" },
//   { label: "New Members",         icon: "🤝", menu: "MemberAgreementAdmin" },
//   { label: "Volunteers",          icon: "🙋", menu: "VolunteerAdmin" },
//   { label: "Contact Mails",       icon: "📧", menu: "Mails" },
//   { label: "Verification Queue",  icon: "✅", menu: "Verification" },
// ];

// const Dashboard = () => {
//   const [counts, setCounts]     = useState({});
//   const [loading, setLoading]   = useState(true);
//   const [recent, setRecent]     = useState([]);

//   useEffect(() => {
//     const fetchAll = async () => {
//       setLoading(true);
//       try {
//         const results = {};
//         await Promise.all(
//           STAT_CARDS.map(async ({ key, col }) => {
//             const snap = await getDocs(collection(db, col));
//             results[key] = snap.size;
//           })
//         );
//         setCounts(results);

//         // Recent help requests
//         const rq = query(
//           collection(db, "HelpRequests"),
//           orderBy("date", "desc"),
//           limit(5)
//         );
//         const rs = await getDocs(rq);
//         setRecent(rs.docs.map((d) => ({ id: d.id, ...d.data() })));
//       } catch (err) {
//         console.error(err);
//       }
//       setLoading(false);
//     };
//     fetchAll();
//   }, []);

//   const formatDate = (ts) => {
//     if (!ts) return "—";
//     const d = ts.toDate ? ts.toDate() : new Date(ts);
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit", month: "short", year: "numeric",
//     });
//   };

//   const STATUS_COLOR = {
//     pending:   "#f39c12",
//     "in-review": "#2980b9",
//     approved:  "#27ae60",
//     rejected:  "#e74c3c",
//     done:      "#27ae60",
//   };

//   return (
//     <div className="db-root">

//       {/* Welcome Banner */}
//       <div className="db-banner">
//         <div className="db-banner-text">
//           <h2 className="db-banner-title">Assalamu Alaikum ﷽</h2>
//           <p className="db-banner-sub">
//             Welcome to the Al-Qaim Welfare Foundation Admin Dashboard.
//             Here's a live overview of all foundation activities.
//           </p>
//         </div>
//         <div className="db-banner-art">🕌</div>
//       </div>

//       {/* Stat Cards */}
//       <div className="db-stats-grid">
//         {STAT_CARDS.map(({ key, label, icon, color, bg }) => (
//           <div
//             key={key}
//             className="db-stat-card"
//             style={{ "--c": color, "--bg": bg }}
//           >
//             <div className="db-stat-icon-wrap" style={{ background: bg }}>
//               <span className="db-stat-icon">{icon}</span>
//             </div>
//             <div className="db-stat-info">
//               <span className="db-stat-count">
//                 {loading ? (
//                   <span className="db-stat-skeleton" />
//                 ) : (
//                   counts[key] ?? 0
//                 )}
//               </span>
//               <span className="db-stat-label">{label}</span>
//             </div>
//             <div className="db-stat-bar" style={{ background: color }} />
//           </div>
//         ))}
//       </div>

//       {/* Bottom Row */}
//       <div className="db-bottom-row">

//         {/* Recent Requests */}
//         <div className="db-card db-recent">
//           <div className="db-card-head">
//             <h3 className="db-card-title">Recent Help Requests</h3>
//             <span className="db-card-badge">{recent.length} latest</span>
//           </div>
//           {loading ? (
//             <div className="db-recent-loading">
//               {[1,2,3].map(i => <div key={i} className="db-recent-skeleton" />)}
//             </div>
//           ) : recent.length === 0 ? (
//             <p className="db-empty-note">No requests yet.</p>
//           ) : (
//             <div className="db-recent-list">
//               {recent.map((r) => (
//                 <div key={r.id} className="db-recent-item">
//                   <div className="db-recent-type-dot" style={{
//                     background:
//                       r.helpType === "medical"   ? "#e74c3c" :
//                       r.helpType === "education" ? "#2980b9" : "#f39c12"
//                   }} />
//                   <div className="db-recent-info">
//                     <span className="db-recent-name">
//                       {r.formData?.fullName || "—"}
//                     </span>
//                     <span className="db-recent-meta">
//                       {r.helpType} · {formatDate(r.date)}
//                     </span>
//                   </div>
//                   <span
//                     className="db-recent-status"
//                     style={{ color: STATUS_COLOR[r.status] || "#888" }}
//                   >
//                     {r.status || "pending"}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Quick Links */}
//         <div className="db-card db-quick">
//           <div className="db-card-head">
//             <h3 className="db-card-title">Quick Navigate</h3>
//           </div>
//           <div className="db-quick-grid">
//             {QUICK_LINKS.map(({ label, icon }) => (
//               <div key={label} className="db-quick-item">
//                 <span className="db-quick-icon">{icon}</span>
//                 <span className="db-quick-label">{label}</span>
//               </div>
//             ))}
//           </div>
//         </div>

//       </div>

//       {/* Foundation Info */}
//       <div className="db-info-strip">
//         <div className="db-info-item">
//           <span className="db-info-icon">📍</span>
//           <span>Mumbai, Maharashtra, India</span>
//         </div>
//         <div className="db-info-item">
//           <span className="db-info-icon">📞</span>
//           <span>+91-7400231537</span>
//         </div>
//         <div className="db-info-item">
//           <span className="db-info-icon">✉️</span>
//           <span>alqaimwelfareinfo@gmail.com</span>
//         </div>
//       </div>

//     </div>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from "react";
import {
  collection, getDocs, orderBy, query, limit, where,
} from "firebase/firestore";
import { db } from "../firebase";
import "../css/dashboard.css";

// ── Config ────────────────────────────────────────────────────
const STAT_CARDS = [
  { key:"helpRequests",  label:"Help Requests",       icon:"📋", col:"HelpRequests",       color:"#162f06", bg:"#eef4eb" },
  { key:"verification",  label:"Verification",         icon:"✅", col:"Verification",        color:"#27ae60", bg:"#e8f8ee" },
  { key:"sadqaBox",      label:"Sadqa Box",            icon:"📦", col:"SadqaBoxRequests",   color:"#c49827", bg:"#fdf8e1" },
  { key:"members",       label:"Member Applications",  icon:"🤝", col:"MemberAgreements",   color:"#2980b9", bg:"#eaf4fb" },
  { key:"volunteers",    label:"Volunteer Forms",      icon:"📝", col:"VolunteerAgreements",color:"#8e44ad", bg:"#f5edfb" },
  { key:"mails",         label:"Contact Mails",        icon:"📧", col:"Mails",              color:"#e74c3c", bg:"#fdf0f0" },
  { key:"collection",    label:"Collections",          icon:"💰", col:"Collection",          color:"#e67e22", bg:"#fef3e6" },
];

const QUICK_LINKS = [
  { label:"Help Requests",     icon:"📋", menu:"Report" },
  { label:"Sadqa Box",         icon:"📦", menu:"SadqaBoxAdmin" },
  { label:"Member Forms",      icon:"🤝", menu:"MemberAgreementAdmin" },
  { label:"Volunteer Forms",   icon:"📝", menu:"VolunteerAdmin" },
  { label:"Contact Mails",     icon:"📧", menu:"Mails" },
  { label:"Verification",      icon:"✅", menu:"Verification" },
  { label:"Our Members",       icon:"👥", menu:"Members" },
  { label:"Our Volunteers",    icon:"🙋", menu:"Volunteers" },
  { label:"Collection",        icon:"💰", menu:"Collection" },
  { label:"Theme Settings",    icon:"🎨", menu:"Theme" },
];

const STATUS_COLOR = {
  pending:"#f39c12","in-review":"#2980b9",approved:"#27ae60",
  rejected:"#e74c3c",done:"#27ae60",
};

const HELP_TYPE_COLOR = {
  medical:"#e74c3c", education:"#2980b9", ration:"#f39c12",
};

// ── Component ─────────────────────────────────────────────────
const Dashboard = ({ onNavigate }) => {
  const [counts,      setCounts]      = useState({});
  const [pending,     setPending]     = useState({});
  const [loading,     setLoading]     = useState(true);
  const [recent,      setRecent]      = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [helpBreakdown, setHelpBreakdown] = useState({ medical:0, education:0, ration:0 });
  const [activity,    setActivity]    = useState([]);

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      // ── Total counts ──
      const results = {};
      await Promise.all(
        STAT_CARDS.map(async ({ key, col }) => {
          try {
            const snap = await getDocs(collection(db, col));
            results[key] = snap.size;
          } catch { results[key] = 0; }
        })
      );
      setCounts(results);

      // ── Pending counts per collection ──
      const pendingResults = {};
      const pendingCols = [
        { key:"helpRequests", col:"HelpRequests" },
        { key:"sadqaBox",     col:"SadqaBoxRequests" },
        { key:"members",      col:"MemberAgreements" },
        { key:"volunteers",   col:"VolunteerAgreements" },
        { key:"mails",        col:"Mails" },
        { key:"verification", col:"Verification" },
      ];
      await Promise.all(
        pendingCols.map(async ({ key, col }) => {
          try {
            const q    = query(collection(db, col), where("status", "==", "pending"));
            const snap = await getDocs(q);
            pendingResults[key] = snap.size;
          } catch { pendingResults[key] = 0; }
        })
      );
      setPending(pendingResults);

      // ── Recent help requests ──
      try {
        const rq   = query(collection(db, "HelpRequests"), orderBy("date", "desc"), limit(6));
        const rs   = await getDocs(rq);
        const docs = rs.docs.map((d) => ({ id: d.id, ...d.data() }));
        setRecent(docs);

        // Help type breakdown
        const breakdown = { medical:0, education:0, ration:0 };
        docs.forEach((r) => { if (r.helpType && breakdown[r.helpType] !== undefined) breakdown[r.helpType]++; });
        setHelpBreakdown(breakdown);
      } catch {}

      // ── Total collection amount ──
      try {
        const colSnap = await getDocs(collection(db, "Collection"));
        const total   = colSnap.docs.reduce((s, d) => s + (parseFloat(d.data().amount) || 0), 0);
        setTotalAmount(total);
      } catch {}

      // ── Recent activity feed (combine mails + sadqa + member) ──
      try {
        const activityItems = [];
        const actCols = [
          { col:"SadqaBoxRequests",   label:"Sadqa Box Request",  icon:"📦" },
          { col:"MemberAgreements",   label:"Member Application",  icon:"🤝" },
          { col:"VolunteerAgreements",label:"Volunteer Form",      icon:"📝" },
          { col:"Mails",              label:"Contact Mail",        icon:"📧" },
        ];
        await Promise.all(
          actCols.map(async ({ col, label, icon }) => {
            try {
              const q    = query(collection(db, col), orderBy("date", "desc"), limit(3));
              const snap = await getDocs(q);
              snap.docs.forEach((d) => {
                const data = d.data();
                activityItems.push({
                  id:    d.id,
                  label,
                  icon,
                  name:  data.fullName || data.details?.name || "—",
                  date:  data.date,
                  status:data.status || "pending",
                });
              });
            } catch {}
          })
        );
        // Sort by date desc
        activityItems.sort((a, b) => {
          const ta = a.date?.toDate?.() || new Date(0);
          const tb = b.date?.toDate?.() || new Date(0);
          return tb - ta;
        });
        setActivity(activityItems.slice(0, 8));
      } catch {}

    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const fmt = (ts) => {
    if (!ts) return "—";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric" });
  };

  const fmtAmount = (n) =>
    n >= 100000
      ? `₹${(n / 100000).toFixed(1)}L`
      : n >= 1000
      ? `₹${(n / 1000).toFixed(1)}K`
      : `₹${n.toLocaleString("en-IN")}`;

  const totalPending = Object.values(pending).reduce((s, v) => s + v, 0);

  return (
    <div className="db-root">

      {/* ── Welcome Banner ── */}
      <div className="db-banner">
        <div className="db-banner-text">
          <h2 className="db-banner-title">Assalamu Alaikum ﷽</h2>
          <p className="db-banner-sub">
            Welcome to the Al-Qaim Welfare Foundation Admin Dashboard.
            {!loading && totalPending > 0 && (
              <span className="db-banner-alert"> ⚠️ {totalPending} item{totalPending !== 1 ? "s" : ""} pending action.</span>
            )}
          </p>
        </div>
        <div className="db-banner-art">🕌</div>
      </div>

      {/* ── Highlight Row ── */}
      <div className="db-highlight-row">
        <div className="db-highlight-card db-hl-green">
          <span className="db-hl-icon">💰</span>
          <div>
            <span className="db-hl-value">{loading ? "…" : fmtAmount(totalAmount)}</span>
            <span className="db-hl-label">Total Collected</span>
          </div>
        </div>
        <div className="db-highlight-card db-hl-red" style={{ cursor: totalPending > 0 ? "pointer" : "default" }}>
          <span className="db-hl-icon">⏳</span>
          <div>
            <span className="db-hl-value">{loading ? "…" : totalPending}</span>
            <span className="db-hl-label">Pending Actions</span>
          </div>
        </div>
        <div className="db-highlight-card db-hl-blue">
          <span className="db-hl-icon">👥</span>
          <div>
            <span className="db-hl-value">{loading ? "…" : (counts.helpRequests || 0)}</span>
            <span className="db-hl-label">Total Help Requests</span>
          </div>
        </div>
        <div className="db-highlight-card db-hl-gold">
          <span className="db-hl-icon">📋</span>
          <div>
            <span className="db-hl-value">{loading ? "…" : (counts.mails || 0)}</span>
            <span className="db-hl-label">Contact Mails</span>
          </div>
        </div>
      </div>

      {/* ── Stat Cards ── */}
      <div className="db-stats-grid">
        {STAT_CARDS.map(({ key, label, icon, color, bg }) => (
          <div
            key={key}
            className="db-stat-card"
            style={{ "--c": color, "--bg": bg }}
            onClick={() => onNavigate && onNavigate(
              key === "helpRequests" ? "Report" :
              key === "verification" ? "Verification" :
              key === "sadqaBox"     ? "SadqaBoxAdmin" :
              key === "members"      ? "MemberAgreementAdmin" :
              key === "volunteers"   ? "VolunteerAdmin" :
              key === "mails"        ? "Mails" :
              key === "collection"   ? "Collection" : "Dashboard"
            )}
          >
            <div className="db-stat-bar" style={{ background: color }} />
            <div className="db-stat-icon-wrap" style={{ background: bg }}>
              <span className="db-stat-icon">{icon}</span>
            </div>
            <div className="db-stat-info">
              <span className="db-stat-count">
                {loading ? <span className="db-stat-skeleton" /> : (counts[key] ?? 0)}
              </span>
              <span className="db-stat-label">{label}</span>
              {!loading && pending[key] > 0 && (
                <span className="db-stat-pending">{pending[key]} pending</span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* ── Middle Row: Help Breakdown + Pending Summary ── */}
      <div className="db-mid-row">
        {/* Help Type Breakdown */}
        <div className="db-card">
          <div className="db-card-head">
            <h3 className="db-card-title">Help Type Breakdown</h3>
            <span className="db-card-badge">Last 6 requests</span>
          </div>
          <div className="db-breakdown-list">
            {[
              { type:"medical",   label:"Medical",   icon:"🏥" },
              { type:"education", label:"Education",  icon:"🎓" },
              { type:"ration",    label:"Ration",     icon:"🌾" },
            ].map(({ type, label, icon }) => {
              const count = helpBreakdown[type] || 0;
              const total = Object.values(helpBreakdown).reduce((a, b) => a + b, 0) || 1;
              const pct   = Math.round((count / total) * 100);
              return (
                <div key={type} className="db-breakdown-item">
                  <span className="db-breakdown-icon">{icon}</span>
                  <div className="db-breakdown-info">
                    <div className="db-breakdown-top">
                      <span className="db-breakdown-label">{label}</span>
                      <span className="db-breakdown-count">{count}</span>
                    </div>
                    <div className="db-breakdown-bar-bg">
                      <div
                        className="db-breakdown-bar"
                        style={{ width: `${pct}%`, background: HELP_TYPE_COLOR[type] }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Pending Summary */}
        <div className="db-card">
          <div className="db-card-head">
            <h3 className="db-card-title">Pending Actions</h3>
            <span className="db-card-badge" style={{ background:"#fef0f0", color:"#e74c3c" }}>
              {totalPending} total
            </span>
          </div>
          <div className="db-pending-list">
            {[
              { key:"helpRequests", label:"Help Requests",  menu:"Report",             icon:"📋" },
              { key:"sadqaBox",     label:"Sadqa Box",       menu:"SadqaBoxAdmin",      icon:"📦" },
              { key:"members",      label:"Member Forms",    menu:"MemberAgreementAdmin",icon:"🤝" },
              { key:"volunteers",   label:"Volunteer Forms", menu:"VolunteerAdmin",     icon:"📝" },
              { key:"mails",        label:"Contact Mails",   menu:"Mails",             icon:"📧" },
              { key:"verification", label:"Verification",    menu:"Verification",       icon:"✅" },
            ].map(({ key, label, menu, icon }) => (
              <div
                key={key}
                className="db-pending-item"
                onClick={() => onNavigate && onNavigate(menu)}
              >
                <span className="db-pending-icon">{icon}</span>
                <span className="db-pending-label">{label}</span>
                <span
                  className="db-pending-badge"
                  style={{
                    background: (pending[key] || 0) > 0 ? "#fff0e8" : "#f0faf0",
                    color:      (pending[key] || 0) > 0 ? "#e67e22" : "#27ae60",
                  }}
                >
                  {loading ? "…" : (pending[key] || 0)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Bottom Row: Recent Requests + Activity Feed ── */}
      <div className="db-bottom-row">

        {/* Recent Help Requests */}
        <div className="db-card db-recent">
          <div className="db-card-head">
            <h3 className="db-card-title">Recent Help Requests</h3>
            <button className="db-card-link" onClick={() => onNavigate && onNavigate("Report")}>
              View all →
            </button>
          </div>
          {loading ? (
            <div className="db-recent-loading">
              {[1,2,3,4].map((i) => <div key={i} className="db-recent-skeleton" />)}
            </div>
          ) : recent.length === 0 ? (
            <p className="db-empty-note">No requests yet.</p>
          ) : (
            <div className="db-recent-list">
              {recent.map((r) => (
                <div key={r.id} className="db-recent-item">
                  <div
                    className="db-recent-type-dot"
                    style={{ background: HELP_TYPE_COLOR[r.helpType] || "#ccc" }}
                  />
                  <div className="db-recent-info">
                    <span className="db-recent-name">{r.formData?.fullName || "—"}</span>
                    <span className="db-recent-meta">
                      {r.helpType} · {r.formData?.phoneNumber || "—"} · {fmt(r.date)}
                    </span>
                  </div>
                  <span
                    className="db-recent-status"
                    style={{ color: STATUS_COLOR[r.status] || "#888" }}
                  >
                    {r.status || "pending"}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Activity Feed */}
        <div className="db-card db-activity">
          <div className="db-card-head">
            <h3 className="db-card-title">Recent Activity</h3>
            <span className="db-card-badge">{activity.length} items</span>
          </div>
          {loading ? (
            <div className="db-recent-loading">
              {[1,2,3].map((i) => <div key={i} className="db-recent-skeleton" />)}
            </div>
          ) : activity.length === 0 ? (
            <p className="db-empty-note">No recent activity.</p>
          ) : (
            <div className="db-activity-list">
              {activity.map((item, i) => (
                <div key={i} className="db-activity-item">
                  <span className="db-activity-icon">{item.icon}</span>
                  <div className="db-activity-info">
                    <span className="db-activity-label">{item.label}</span>
                    <span className="db-activity-name">{item.name}</span>
                  </div>
                  <div className="db-activity-right">
                    <span
                      className="db-activity-status"
                      style={{ color: STATUS_COLOR[item.status] || "#888" }}
                    >
                      {item.status}
                    </span>
                    <span className="db-activity-date">{fmt(item.date)}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ── Quick Navigate ── */}
      <div className="db-card">
        <div className="db-card-head">
          <h3 className="db-card-title">Quick Navigate</h3>
        </div>
        <div className="db-quick-grid">
          {QUICK_LINKS.map(({ label, icon, menu }) => (
            <button
              key={menu}
              className="db-quick-item"
              onClick={() => onNavigate && onNavigate(menu)}
            >
              <span className="db-quick-icon">{icon}</span>
              <span className="db-quick-label">{label}</span>
              {pending[
                menu === "Report" ? "helpRequests" :
                menu === "SadqaBoxAdmin" ? "sadqaBox" :
                menu === "MemberAgreementAdmin" ? "members" :
                menu === "VolunteerAdmin" ? "volunteers" :
                menu === "Mails" ? "mails" :
                menu === "Verification" ? "verification" : null
              ] > 0 && (
                <span className="db-quick-badge">
                  {pending[
                    menu === "Report" ? "helpRequests" :
                    menu === "SadqaBoxAdmin" ? "sadqaBox" :
                    menu === "MemberAgreementAdmin" ? "members" :
                    menu === "VolunteerAdmin" ? "volunteers" :
                    menu === "Mails" ? "mails" :
                    menu === "Verification" ? "verification" : null
                  ]}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* ── Info Strip ── */}
      <div className="db-info-strip">
        <div className="db-info-item"><span className="db-info-icon">📍</span><span>Mumbai, Maharashtra, India</span></div>
        <div className="db-info-item"><span className="db-info-icon">📞</span><span>+91-7400231537</span></div>
        <div className="db-info-item"><span className="db-info-icon">📞</span><span>+91-7738805577</span></div>
        <div className="db-info-item"><span className="db-info-icon">✉️</span><span>alqaimwelfareinfo@gmail.com</span></div>
        <div className="db-info-item"><span className="db-info-icon">⏰</span><span>Dashboard refreshed: {new Date().toLocaleTimeString("en-IN")}</span></div>
      </div>

    </div>
  );
};

export default Dashboard;